<template>
  <form-dialog
    class="text-capitalize"
    title="Edit Expenses"
    :disable-submit="!division && !listingId && !expenseType"
    @close="onClose"
    @submit="submit"
  >
    <template #activator="{ on }">
      <v-list-item v-on="on">Edit expenses</v-list-item>
    </template>
    <v-select
      v-model="division"
      label="Related Division"
      :items="itemsDivisions"
      dense
      outlined
    />
    <listing-select
      v-if="hasAbility('super-accountant')"
      :no-prepend-icon="true"
      :outlined="true"
      :dense="true"
      :clearable="true"
      item-text="nickname"
      :hide-title="true"
      :pre-selected.sync="listingId"
      :disabled="expenseType === 'BusinessExpense'"
      :placeholder="
        expenseType === 'BusinessExpense' ? 'N/A for business expenses' : ''
      "
    />
    <v-select
      v-model="expenseType"
      label="Expense Type"
      :items="expenseTypeItems"
      dense
      outlined
      clearable
      @change="onExpenseTypeChange"
    />
  </form-dialog>
</template>

<script>
import FormDialog from 'components/common/form-dialog'
import CommonFunctions from 'components/mixins/common_functions'
import FormRules from 'components/mixins/form-rules-mixin'
import ListingSelect from 'components/listing-select'
import { isBoolean } from 'lodash'
export default {
  name: 'ExpensesEditModal',
  components: { ListingSelect, FormDialog },
  mixins: [CommonFunctions, FormRules],
  props: ['isSetup'],
  data() {
    return {
      division: null,
      listingId: null,
      expenseType: null,
    }
  },
  computed: {
    itemsDivisions() {
      if (!isBoolean(this.isSetup)) {
        return this.budgetDivisions.concat(this.operationalDivisions)
      }
      if (this.isSetup) {
        return this.budgetDivisions
      }
      return this.operationalDivisions
    },
    expenseTypeItems() {
      return [
        { text: 'Property', value: 'ClientExpense' },
        { text: 'Business', value: 'BusinessExpense' },
      ]
    },
  },
  methods: {
    onClose() {
      this.division = null
      this.listingId = null
      this.expenseType = null
    },
    onExpenseTypeChange(val) {
      if (val === 'BusinessExpense') {
        this.listingId = null
      }
    },
    submit() {
      const payload = {}
      if (this.division) {
        payload.related_division = this.division
      }
      if (this.listingId) {
        payload.listing_id = this.listingId
      }
      if (this.expenseType) {
        payload.type = this.expenseType
      }
      this.$emit('submit', payload)
    },
  },
}
</script>

<style scoped></style>
